export default "__VITE_ASSET__DHtLHyWI__"